<template>
  <div class="ui-select">
    <div class="value custom-select" :class="{ training: type != 'homework' }" @click="isDropdownOpen = !isDropdownOpen">
      {{ getPrintedValue }}
    </div>

    <fieldset v-if="isDropdownOpen" class="options">
      <div v-for="(column, i) in optionsColumns" :key="String(i)" class="column">
        <div v-for="(item, i) in column" :key="String(i)" class="item">
          <label>
            <input type="radio" :value="selected" :key="String(item)" :checked="item.toString() == selected.toString()"
              @change="changeSelect(item)" />
            {{ getValue(item) }}
          </label>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'select',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: ['selected', 'options', 'optionsColumns', 'type'],
  data() {
    return {
      isDropdownOpen: false
    }
  },
  methods: {
    getValue(value) {
      if (typeof value == 'object') {
        return `${value[0]}-${value[1]}`
      }

      return value
    },

    changeSelect(value) {
      this.$emit('change', value)

      this.isDropdownOpen = false
    }
  },

  computed: {
    getPrintedValue() {
      if (typeof this.selected == 'object') {
        return `${this.selected[0]}-${this.selected[1]}`
      }

      return this.selected
    }
  }
}
</script>

<style lang="scss">
.ui-select {
  width: 100%;
  position: relative;
}

.value {
  cursor: pointer;
  user-select: none;
}

.custom-select.training {
  border: 2px solid #6f42c1 !important;
  border-radius: 12px !important;
  color: #6f42c1 !important;
}

.options {
  position: absolute;

  top: 40px;
  right: 0;

  background-color: #fff;

  display: flex;
  justify-content: space-between;
  border: 1px solid #ced4da;

  padding: 10px;
  width: fit-content;

  border-radius: 12px;
  z-index: 2;

  &.training {
    border: 2px solid #6f42c1;
  }

  & .column {
    margin: 5px;

    text-align: center;
  }

  & .item {
    // min-width: 60px;
    margin: auto;
    white-space: nowrap;
    text-align: center;

    & label {
      margin: auto;
    }
  }

  & input[type='radio'] {
    width: 15px;
    height: 15px;

    margin-right: 3px;

    accent-color: #6f42c1;
  }
}
</style>